'use strict';

define('vb/private/stateManagement/layoutMixin',[], () => {
  /**
   * Mixin that is used by layout container and extension to load translation bundles similarly
   */
  const LayoutMixin = (superclass) => class extends superclass {
    /**
     * Overrides the base impl, so we can add "allowSelfRelative: false"
     *
     * @param {Object} [options] Special directives for the bundle definitions
     * @param {boolean} [options.preferV1] If V1 translations config is present, ignore V2 translations config.
     * @param {boolean} [options.proxyBundles] Make proxies for bundles and don't wait for the bundles to be loaded
     * @param {Object} [options.replacementValues] (V1) map of key/value pairs for expressions in path
     * @param {boolean} [options.allowSelfRelative] (V1) let the container JSON use "./" to mean 'relative to the
     * same folder'
     * @param {boolean} [options.isUnrestrictedRelative] (V1) you can reach outside of your current folder
     * (only app-flow)
     * @param {string} [options.location] (V2) Location (directory) of bundles
     * @param {string} [options.defaultBundleResourceName] (V2) Filename of default bundle in location
     *
     * @returns {Promise<Object>} a promise that resolves with the bundles model
     */
    loadTranslationBundles(options) {
      if (this.loadBundlesPromise) {
        // Do not bother checking everything again
        return this.loadBundlesPromise;
      }

      // (V1) let the container JSON use "./" to mean 'relative to the same folder
      const disallowSelfRelative = { allowSelfRelative: false };
      return super.loadTranslationBundles(options ? Object.assign(options, disallowSelfRelative)
        : disallowSelfRelative);
    }

    /**
     * The name of the resource to be used to load layout or extension layout.
     * @type {string}
     */
    get fullName() {
      return this.name;
    }
  };

  return LayoutMixin;
});

